import { ngRoute } from '../../../../app/routing/ngRoute';

angular.module('signalview.chartTemplates').factory('chartTemplates', [
    function () {
        const templates = {};

        const service = {
            register: function (name, template) {
                templates[name] = template;
            },
            get: function (name) {
                return templates[name];
            },
            fromUrl: function () {
                // Parses URL parameters to create a chart from a template
                //
                // Usage examples:
                // 1. Multiple metrics with per-metric filters:
                //    ?template=default&filters=sf_metric:cpu.utilization&filters=sf_metric:memory.utilization
                //    &filters=sf_metric_filter_0:host:web-server-1&filters=sf_metric_filter_1:host:db-server-1
                //
                // 2. Mix of global and per-metric filters:
                //    ?template=default&filters=sf_metric:cpu.utilization&filters=environment:production
                //    &filters=sf_metric_filter_0:host:web-1
                //    (environment:production applies to all metrics, host:web-1 only to cpu.utilization)
                //
                // 3. Multiple filters per metric:
                //    ?template=default&filters=sf_metric:requests.count
                //    &filters=sf_metric_filter_0:host:server-1&filters=sf_metric_filter_0:region:us-east
                //
                let templateChart = null;
                const filters = {};
                const perMetricFilters = {}; // Store filters for each metric index

                if (ngRoute.params.filters) {
                    let filtersArray = ngRoute.params.filters;

                    if (angular.isString(filtersArray)) filtersArray = [filtersArray];

                    filtersArray.forEach(function (filter) {
                        // Split key:value
                        if (!filter) return;

                        const parts = filter.split(':');
                        const key = parts[0];
                        const value = parts.splice(1).join(':');

                        // Check if this is a per-metric filter (format: sf_metric_filter_N)
                        const metricFilterMatch = key.match(/^sf_metric_filter_(\d+)$/);
                        if (metricFilterMatch) {
                            const metricIndex = parseInt(metricFilterMatch[1], 10);
                            if (!perMetricFilters[metricIndex]) {
                                perMetricFilters[metricIndex] = {};
                            }
                            // Parse the value as filter_key:filter_value
                            const filterParts = value.split(':');
                            const filterKey = filterParts[0];
                            const filterValue = filterParts.splice(1).join(':');

                            // Support multiple filters for the same metric
                            if (perMetricFilters[metricIndex][filterKey]) {
                                if (!angular.isArray(perMetricFilters[metricIndex][filterKey])) {
                                    perMetricFilters[metricIndex][filterKey] = [
                                        perMetricFilters[metricIndex][filterKey],
                                    ];
                                }
                                perMetricFilters[metricIndex][filterKey].push(filterValue);
                            } else {
                                perMetricFilters[metricIndex][filterKey] = filterValue;
                            }
                        } else {
                            // Support multiple values for the same key (especially sf_metric)
                            if (filters[key]) {
                                // Convert to array if not already
                                if (!angular.isArray(filters[key])) {
                                    filters[key] = [filters[key]];
                                }
                                filters[key].push(value);
                            } else {
                                filters[key] = value;
                            }
                        }
                    });
                }

                if (ngRoute.params.template) {
                    const template = service.get(ngRoute.params.template);
                    templateChart = template(filters, perMetricFilters);
                }

                return templateChart;
            },
        };
        return service;
    },
]);
